
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trains/news/[id]",
      function () {
        return require("private-next-pages/trains/news/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trains/news/[id]"])
      });
    }
  